import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, isRef as _isRef } from "vue";
import _imports_0 from '@/assets/images/copy.png';
import _imports_1 from '@/assets/images/exchange.png';
import _imports_2 from '@/assets/images/add.png';
import _imports_3 from '@/assets/images/diagnose.png';
import _imports_4 from '@/assets/images/real-name.png';
import _imports_5 from '@/assets/images/infinite.gif';
import _imports_6 from '@/assets/images/online-service.png';
var _hoisted_1 = {
  class: "home-container"
};
var _hoisted_2 = {
  class: "card-info-container"
};
var _hoisted_3 = {
  class: "card-number-container"
};
var _hoisted_4 = {
  class: "card-number-wrapper"
};
var _hoisted_5 = {
  class: "card-number"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  class: "card-copy-button"
};
var _hoisted_9 = {
  class: "operator-container"
};
var _hoisted_10 = {
  class: "card-state-container"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "state-label"
}, "状态：", -1);
var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "change-card-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "卡板列表"
})], -1);
var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "change-card-text"
}, "卡板列表", -1);
var _hoisted_14 = [_hoisted_12, _hoisted_13];
var _hoisted_15 = {
  class: "operation-container"
};
var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "添加卡板"
})], -1);
var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "添加卡板", -1);
var _hoisted_18 = [_hoisted_16, _hoisted_17];
var _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "智能诊断"
})], -1);
var _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "智能诊断", -1);
var _hoisted_21 = [_hoisted_19, _hoisted_20];
var _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "实名认证"
})], -1);
var _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-text"
}, "实名认证", -1);
var _hoisted_24 = [_hoisted_22, _hoisted_23];
var _hoisted_25 = {
  class: "package-info-container"
};
var _hoisted_26 = {
  class: "current-package-title-line"
};
var _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "current-package-label"
}, "生效套餐：", -1);
var _hoisted_28 = {
  class: "current-package-title"
};
var _hoisted_29 = {
  key: 0
};
var _hoisted_30 = ["title", "onClick"];
var _hoisted_31 = {
  class: "package-item-wrapper"
};
var _hoisted_32 = {
  class: "package-title"
};
var _hoisted_33 = {
  class: "package-info basic"
};
var _hoisted_34 = {
  class: "package-type-price"
};
var _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "package-type"
}, "体验包", -1);
var _hoisted_36 = {
  class: "package-price"
};
var _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "￥", -1);
var _hoisted_38 = {
  class: "package-button"
};
var _hoisted_39 = {
  key: 0,
  class: "package-info-container"
};
var _hoisted_40 = {
  class: "current-package-title-line"
};
var _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "current-package-label"
}, "生效套餐：", -1);
var _hoisted_42 = {
  class: "current-package-title"
};
var _hoisted_43 = {
  key: 0,
  class: "current-package-animation"
};
var _hoisted_44 = {
  src: _imports_5,
  alt: "无限流量"
};
var _hoisted_45 = {
  key: 1,
  class: "current-package-animation"
};
var _hoisted_46 = {
  key: 2,
  class: "package-effective-time"
};
var _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "effective-time-label"
}, "生效时间：", -1);
var _hoisted_48 = {
  class: "effective-time-text"
};
var _hoisted_49 = {
  key: 3,
  class: "package-effective-time"
};
var _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "effective-time-label"
}, "账期进度：", -1);
var _hoisted_51 = {
  class: "effective-time-text"
};
var _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  class: "modules-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "modules-title"
}, "温馨提示")], -1);
var _hoisted_53 = {
  class: "kind-reminder"
};
var _hoisted_54 = ["onTouchstart", "onMousedown", "onTouchend", "onMouseup"];
var _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "在线客服"
}, null, -1);
var _hoisted_56 = [_hoisted_55];
var _hoisted_57 = {
  style: {
    "padding": "15px 20px",
    "font-size": "15px",
    "color": "#646566"
  }
};
var _hoisted_58 = {
  style: {
    "width": "100%",
    "display": "flex",
    "border-top": "1px solid #ccc"
  }
};
var _hoisted_59 = {
  class: "btn",
  style: {
    "width": "100%",
    "font-size": "15px",
    "color": "#fff",
    "border": "transparent",
    "background": "#437fff"
  }
};
var _hoisted_60 = {
  style: {
    "padding": "15px 20px",
    "font-size": "15px",
    "color": "#646566"
  }
};
var _hoisted_61 = {
  style: {
    "width": "100%",
    "display": "flex",
    "border-top": "1px solid #ccc"
  }
};
var _hoisted_62 = {
  class: "btn",
  style: {
    "width": "100%",
    "font-size": "15px",
    "padding": "15px 0",
    "color": "#fff",
    "border": "1px solid #437fff",
    "background": "#437fff"
  }
};
var _hoisted_63 = {
  style: {
    "width": "100%"
  }
};
var _hoisted_64 = ["src"];
import { reactive, ref, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { showConfirmDialog, showNotify, showToast } from "vant";
import { toClipboard } from "@soerenmartius/vue3-clipboard";
import router from "@/router";
import { customRouterPush, isWeChat } from "@/common/utils";
import PackageList from "@/components/PackageList.vue";
import CardList from "@/components/CardList.vue";
import DiagnosePopup from "@/components/DiagnosePopup.vue";
import FlowPercentage from "./modules/FlowPercentage.vue";
import jweixin from "weixin-js-sdk-ts";
import {
// apiGetCardState,
apiGetCurrentPackage, getRefresh, getAccessToken, apiWeChatVerify,
// apiGetHisOrderFLowFlag,
apiGetIccidByUserId, apiGetAgentApplicationConfig, apiGetHomePagePopupInfo, apiGetRealNameInfo, apiGetCardList, getAnyUserPackageOrdinaryExperience, apiOrderPackageCheck, postAnyUserDoOrderFreeOrder, apiWeChatConfig } from "@/common/api";
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup: function (__props) {
    var store = useStore();
    // let orderFlowHisFlag = true;
    var showCurrentPackageImg = false;
    // const kindlyReminder = computed(
    //   () => cardState.value?.kindlyReminder?.split("\n") || []
    // );
    var showTimer = window.location.host !== 'bz.hzfandeng.com';
    var route = useRoute();
    var params = route.params,
      query = route.query;
    var tenantId = params.tenantId,
      iccid = params.iccid;
    var id = query.id,
      user = query.user,
      refreshTokenSource = query.refreshToken,
      source = query.source;
    var realNameShow = ref(false);
    var realNameShow2 = ref(false);
    var codeShow = ref(false);
    store.commit("setSource", source);
    store.commit("setTenantId", tenantId);
    store.commit("setUserId", user);
    store.commit("setAppId", id);
    store.commit("setIccid", iccid);
    // 取消弹窗实名
    function handleCancel() {
      realNameShow.value = false;
      realNameShow2.value = false;
    }
    // 点击弹窗去实名
    function handleConfirm() {
      realNameShow.value = false;
    }
    // 点击h5弹窗去实名
    function handleConfirm2() {
      realNameShow2.value = false;
      codeShow.value = true;
    }
    // 
    function getWxConfig() {
      // 获取路径地址
      var puth = location.href;
      var index = puth.indexOf(".com") + 4;
      var route = puth.substring(index); // 截取路径地址.com后的字符串
      var data = {
        id: store.state.appId,
        route: route
      };
      return new Promise(function (resolve, reject) {
        // 调用接口获取签名数据
        apiWeChatConfig(data).then(function (res) {
          if (res.code === 0) {
            resolve(res);
          } else {
            reject(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
    function handleWxConfig() {
      return new Promise(function (resolve, reject) {
        getWxConfig().then(function (res) {
          jweixin.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "previewImage"],
            openTagList: ["wx-open-launch-weapp"]
          });
          jweixin.ready(function () {
            resolve("wxConfig ready");
          });
          jweixin.error(function (err) {
            reject(err);
          });
        });
      });
    }
    handleWxConfig().catch(function (err) {
      // showToast(err);
    });
    function _getRefresh() {
      // const refreshTokenSource: any = query.refreshToken;
      var refreshToken = encodeURIComponent(refreshTokenSource);
      var params = {
        refreshToken: refreshToken,
        iccid: iccid
      };
      getRefresh(params).then(function (res) {
        getAccessToken({
          iccid: iccid
        }).then(function (data) {
          if (data.code === 201) {
            _getRefresh();
          }
        });
      });
    }
    var hasCard = ref(true);
    function checkCardList() {
      if (!isWeChat()) return;
      var pageParams = {
        pageSize: 10,
        pageNo: 1
      };
      apiGetCardList(iccid, pageParams, store.state.userId).then(function (res) {
        if (res.code === 0 && res.data.length <= 0) {
          showBindCardDialog();
          hasCard.value = false;
        } else {
          hasCard.value = true;
        }
      });
    }
    function showBindCardDialog() {
      showConfirmDialog({
        title: "绑定卡板",
        message: "当前暂未绑卡，请先绑定卡板！",
        showCancelButton: true,
        confirmButtonText: "去绑卡",
        beforeClose: function (action) {
          return new Promise(function (resolve) {
            if (action === "confirm") {
              addCard();
            }
            resolve(true);
          });
        }
      });
    }
    var linkUrlImg = ref('');
    function realName() {
      if (!hasCard.value) {
        showBindCardDialog();
        return;
      }
      apiGetRealNameInfo({
        iccid: iccid
      }).then(function (res) {
        var code = res.code,
          data = res.data;
        if (code === 0) {
          var popupType = data.popupType,
            popupTitle = data.popupTitle,
            popupContent = data.popupContent,
            linkUrl = data.linkUrl,
            haveCancelButton = data.haveCancelButton,
            button_1 = data.button;
          if (popupType === "2" || popupType === "3") {
            showConfirmDialog({
              title: popupTitle,
              message: popupContent,
              showCancelButton: haveCancelButton,
              confirmButtonText: button_1.buttonTitle,
              beforeClose: function (action) {
                return new Promise(function (resolve) {
                  if (action === "confirm" && button_1.path) {
                    window.location.href = button_1.path;
                  }
                  resolve(true);
                });
              }
            });
          } else if (popupType === "1" && linkUrl) {
            linkUrlImg.value = linkUrl;
            if (button_1.type == "1") {
              if (isWeiXin()) {
                realNameShow.value = true;
              } else {
                codeShow.value = true;
              }
            } else {
              window.location.href = linkUrl;
            }
          }
        }
      });
    }
    var diagnosePopup = ref();
    function diagnose() {
      if (!hasCard.value) {
        showBindCardDialog();
        return;
      }
      // if (!currentPackageInfo.value?.orderFlowFlag) {
      //   showToast("暂未订购流量套餐");
      //   return;
      // }
      if (iccid === "0") {
        showToast("暂无卡板");
        return;
      }
      router.push({
        path: "/diagnosis",
        query: {
          iccid: iccid
        }
      });
      // diagnosePopup.value.open();
    }

    function addCard() {
      router.push("/add-card");
    }
    // function orderRecords() {
    //   router.push({
    //     path: "/order-records",
    //     query: { iccid },
    //   });
    // }
    function copy(val) {
      toClipboard(val).then(function () {
        showNotify({
          type: "success",
          message: "复制成功！",
          duration: 1000
        });
      });
    }
    var cardState = ref({});
    // async function getCardState() {
    //   const res = await apiGetCardState({ iccid });
    //   if (res.code === 0) {
    //     cardState.value = res.data;
    //     if (res.data.orderFlowFlag) {
    //       orderFlowHisFlag = false;
    //     }
    //   }
    // }
    var currentPackageInfo = ref({});
    function getCurrentPackage() {
      apiGetCurrentPackage({
        iccid: iccid
      }).then(function (res) {
        if (res.code === 0) {
          // showCurrentPackage = false;
          showCurrentPackageImg = true;
          var _a = res.data,
            cardInfoResultVO = _a.cardInfoResultVO,
            orderInfoResultVO = _a.orderInfoResultVO;
          cardState.value = cardInfoResultVO;
          currentPackageInfo.value = orderInfoResultVO;
        }
      });
    }
    // 判断是否为微信环境
    function isWeiXin() {
      var ua = window && window.navigator.userAgent.toLowerCase(); // 不加window部分Android机会显示不了提示图，即判断不了是否是微信
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    }
    //弹窗内容赋值
    var title = ref('');
    var message = ref('');
    var confirmButtonText = ref('');
    var showCancelButton = ref(false);
    function getHomePagePopupInfo() {
      apiGetHomePagePopupInfo({
        iccid: iccid
      }).then(function (res) {
        if (res.code === 0) {
          var _a = res.data,
            popupType = _a.popupType,
            popupTitle = _a.popupTitle,
            popupContent = _a.popupContent,
            haveCancelButton = _a.haveCancelButton,
            button_2 = _a.button;
          console.log('res>>', res);
          if (popupType !== "1") {
            if (button_2.type == "1") {
              title.value = popupTitle;
              message.value = popupContent;
              confirmButtonText.value = button_2.buttonTitle;
              showCancelButton.value = haveCancelButton;
              // 判断是否为微信环境
              if (isWeiXin()) {
                realNameShow.value = true;
                title.value = popupTitle;
                message.value = popupContent;
                confirmButtonText.value = button_2.buttonTitle;
              } else {
                linkUrlImg.value = button_2.path;
                realNameShow2.value = true;
                // showConfirmDialog({
                //   title: popupTitle,
                //   message: popupContent,
                //   showCancelButton: haveCancelButton,
                //   confirmButtonText: button.buttonTitle,
                //   beforeClose: (action) =>
                //     new Promise((resolve) => {
                //       if (action === "confirm" && button.path) {
                //         codeShow.value = true;
                //       }
                //       resolve(true);
                //     }),
                // });
              }
            } else {
              showConfirmDialog({
                title: popupTitle,
                message: popupContent,
                showCancelButton: haveCancelButton,
                confirmButtonText: button_2.buttonTitle,
                beforeClose: function (action) {
                  return new Promise(function (resolve) {
                    if (action === "confirm" && button_2.path) {
                      window.location.href = button_2.path;
                    }
                    resolve(true);
                  });
                }
              });
            }
          }
        }
      });
    }
    var cardList = ref();
    function openCardList() {
      cardList.value.open(iccid);
    }
    var flowUsed = ref(0);
    onMounted(function () {
      flowUsed.value = 60;
    });
    // 获取代理商应用配置
    var showAnyButton = ref([]);
    var kindlyReminder = ref([]);
    var noneOrderPrompt = ref("");
    function getAgentApplicationConfig() {
      apiGetAgentApplicationConfig({
        iccid: iccid
      }).then(function (res) {
        var _a, _b;
        showAnyButton.value = (_a = res.data.showAnyButton) === null || _a === void 0 ? void 0 : _a.split(",");
        kindlyReminder.value = ((_b = res.data.kindlyReminder) === null || _b === void 0 ? void 0 : _b.split("\n")) || [];
        noneOrderPrompt.value = res.data.noneOrderPrompt;
      });
    }
    // 微信认证
    function weChatVerify() {
      apiWeChatVerify(iccid, id).then(function (res) {
        if (res.code === 0) {
          window.location.href = res.data;
        } else {
          showToast(res.msg);
        }
      });
    }
    var initHeight = 0;
    // 控制页面展示
    var pageShow = ref(false);
    function showPage() {
      pageShow.value = true;
      nextTick().then(function () {
        initHeight = homeViewContainer.value.clientHeight;
      });
    }
    if (isWeChat() && !user) {
      weChatVerify();
    } else if (iccid === "0") {
      getIccidByUserId().then(function (res) {
        if (res.code === 0 && res.data) {
          customRouterPush("", route, {
            iccid: res.data
          });
        } else {
          showPage();
        }
      }).catch(function (err) {
        showToast(err);
        showPage();
      });
    } else {
      showPage();
    }
    // 通过userId获取iccid
    function getIccidByUserId() {
      return new Promise(function (resolve, reject) {
        apiGetIccidByUserId({
          userId: store.state.userId
        }).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
    // 移动距离阈值（像素），低于此值视为点击而非拖拽
    var MOVE_THRESHOLD = 6;
    // 客服悬浮按钮位置信息
    var servicePosition = reactive({
      bottom: 80,
      onMouseDown: false,
      startBottom: 0,
      startPageY: 0,
      moved: false
    });
    // 客服悬浮按钮元素实例
    var homeViewContainer = ref();
    // 点击链接至客服页面
    function navigateToService() {
      router.push("/service");
    }
    // 客服悬浮按钮触摸触发事件
    function onTouchstart(e) {
      servicePosition.onMouseDown = true;
      var pageY = e.touches[0].pageY;
      servicePosition.startPageY = pageY;
      servicePosition.moved = false;
      servicePosition.startBottom = servicePosition.bottom;
    }
    // 客服悬浮按钮鼠标按下事件
    function onMousedown(e) {
      servicePosition.onMouseDown = true;
      var pageY = e.pageY;
      servicePosition.startPageY = pageY;
      servicePosition.moved = false;
      servicePosition.startBottom = servicePosition.bottom;
    }
    // 客服悬浮按钮触摸结束事件
    function onTouchend() {
      servicePosition.onMouseDown = false;
      if (!servicePosition.moved) {
        navigateToService();
        servicePosition.moved = false;
      }
    }
    // 客服悬浮按钮鼠标抬起事件
    function onMouseup() {
      servicePosition.onMouseDown = false;
      if (!servicePosition.moved) {
        navigateToService();
        servicePosition.moved = false;
      }
    }
    // 客服悬浮按钮触摸移动事件
    function onTouchmove(e) {
      if (!servicePosition.onMouseDown) return;
      var pageY = e.touches[0].pageY;
      var startBottom = servicePosition.startBottom,
        startPageY = servicePosition.startPageY;
      // 计算移动距离，小于阈值时视为手指抖动，不标记为拖拽
      var moveDistance = Math.abs(pageY - startPageY);
      if (moveDistance < MOVE_THRESHOLD) return;
      // 使用 clamp 确保位置在合法范围内，避免边界拖拽误触发点击
      var tempButton = startBottom - pageY + startPageY;
      var clampedBottom = Math.min(Math.max(tempButton, 20), initHeight - 60);
      // 确认真正的拖拽行为后才设置 moved 标志
      servicePosition.moved = true;
      servicePosition.bottom = clampedBottom;
    }
    // 客服悬浮按钮鼠标移动事件
    function onMousemove(e) {
      if (!servicePosition.onMouseDown) return;
      var pageY = e.pageY;
      var startBottom = servicePosition.startBottom,
        startPageY = servicePosition.startPageY;
      // 计算移动距离，小于阈值时视为鼠标抖动，不标记为拖拽
      var moveDistance = Math.abs(pageY - startPageY);
      if (moveDistance < MOVE_THRESHOLD) return;
      // 使用 clamp 确保位置在合法范围内，避免边界拖拽误触发点击
      var tempButton = startBottom - pageY + startPageY;
      var clampedBottom = Math.min(Math.max(tempButton, 20), initHeight - 60);
      // 确认真正的拖拽行为后才设置 moved 标志
      servicePosition.moved = true;
      servicePosition.bottom = clampedBottom;
    }
    var packageList = ref([]);
    function _getAnyUserPackageOrdinaryExperience() {
      getAnyUserPackageOrdinaryExperience({
        iccid: iccid
      }).then(function (res) {
        if (res.code === 0) {
          packageList.value = res.data;
        }
      });
    }
    function buyPackage(record) {
      if (Number(record.agentSalePrice) === 0) {
        console.log("免费");
        var params_1 = {
          iccid: iccid,
          // packageId: record.packageId,
          agentPackageId: record.id
        };
        postAnyUserDoOrderFreeOrder(params_1).then(function (res) {
          if (res.code === 0) {
            showToast(res.data);
            setTimeout(function () {
              _getAnyUserPackageOrdinaryExperience();
              getCurrentPackage();
            }, 2000);
          } else {
            showToast(res.msg);
          }
        });
      } else {
        apiOrderPackageCheck({
          iccid: iccid
        }).then(function (res) {
          console.log("🚀 ~ apiOrderPackageCheck ~ res:", res);
          var code = res.code,
            data = res.data;
          if (code !== 0) {
            showToast(res.msg);
            return;
          }
          var popupType = data.popupType,
            popupTitle = data.popupTitle,
            popupContent = data.popupContent,
            haveCancelButton = data.haveCancelButton,
            button = data.button;
          if (popupType === "1") {
            var packageId = record.packageId,
              id_1 = record.id;
            router.push({
              path: "/package-buy",
              query: {
                packageId: packageId,
                iccid: iccid,
                id: id_1
              }
            });
          } else if (popupType === "2") {
            showConfirmDialog({
              title: popupTitle,
              message: popupContent,
              showCancelButton: haveCancelButton,
              confirmButtonText: button.buttonTitle,
              beforeClose: function (action) {
                return new Promise(function (resolve) {
                  if (action === "confirm" && button.path) {
                    window.location.href = button.path;
                  }
                  resolve(true);
                });
              }
            });
          }
        });
      }
    }
    // getCardState();
    getAgentApplicationConfig();
    getCurrentPackage();
    getHomePagePopupInfo();
    checkCardList();
    _getRefresh();
    _getAnyUserPackageOrdinaryExperience();
    return function (_ctx, _cache) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      var _component_wx_open_launch_weapp = _resolveComponent("wx-open-launch-weapp");
      var _component_van_dialog = _resolveComponent("van-dialog");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "home-view",
        ref_key: "homeViewContainer",
        ref: homeViewContainer,
        onTouchmove: onTouchmove,
        onMousemove: onMousemove
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createTextVNode(" ICCID： "), _unref(iccid) === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_6, "暂无卡板")) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(iccid)), 1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: _imports_0,
        alt: "copy",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return copy(_unref(iccid));
        })
      })])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", {
        class: _normalizeClass(["state-value", "state-".concat(cardState.value.cardStatus)])
      }, _toDisplayString(cardState.value.cardStatusShow), 3)]), _unref(isWeChat)() && showAnyButton.value.includes('2') ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "change-card-wrapper",
        onClick: openCardList
      }, _hoisted_14)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_unref(isWeChat)() && showAnyButton.value.includes('0') ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "button add-card-button",
        onClick: addCard
      }, _hoisted_18)) : _createCommentVNode("", true), showAnyButton.value.includes('1') ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "button diagnose-button",
        onClick: diagnose
      }, _hoisted_21)) : _createCommentVNode("", true), showAnyButton.value.includes('5') ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "button real-name",
        onClick: realName
      }, _hoisted_24)) : _createCommentVNode("", true)])]), _withDirectives(_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, _toDisplayString(((_a = currentPackageInfo.value) === null || _a === void 0 ? void 0 : _a.packageName) || "暂未订购流量套餐"), 1)]), packageList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "package-item",
          key: item,
          title: item,
          onClick: function ($event) {
            return buyPackage(item);
          }
        }, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(item.agentPackageName), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_hoisted_37, _createTextVNode(_toDisplayString(item.agentSalePriceShow), 1)])]), _createElementVNode("div", _hoisted_38, _toDisplayString(Number(item.agentSalePriceShow) == 0 ? "免费领取" : "立即订购"), 1)])])], 8, _hoisted_30);
      }), 128))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
        class: "experience-traffic"
      }, _toDisplayString(noneOrderPrompt.value), 513), [[_vShow, packageList.value.length === 0]])], 512), [[_vShow, !((_b = currentPackageInfo.value) === null || _b === void 0 ? void 0 : _b.orderFlowFlag)]]), ((_c = currentPackageInfo.value) === null || _c === void 0 ? void 0 : _c.orderFlowFlag) ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, _toDisplayString(((_d = currentPackageInfo.value) === null || _d === void 0 ? void 0 : _d.packageName) || "暂未订购流量套餐"), 1)]), ((_e = currentPackageInfo.value) === null || _e === void 0 ? void 0 : _e.boundlessFlag) === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_withDirectives(_createElementVNode("img", _hoisted_44, null, 512), [[_vShow, _unref(showCurrentPackageImg)]])])) : ((_f = currentPackageInfo.value) === null || _f === void 0 ? void 0 : _f.boundlessFlag) === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createVNode(FlowPercentage, {
        flowCount: (_g = currentPackageInfo.value) === null || _g === void 0 ? void 0 : _g.billFlowCount,
        flowSurplus: (_h = currentPackageInfo.value) === null || _h === void 0 ? void 0 : _h.billSurplusFlow
      }, null, 8, ["flowCount", "flowSurplus"])])) : _createCommentVNode("", true), _unref(showTimer) ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, _toDisplayString(currentPackageInfo.value.startDate) + " - " + _toDisplayString(currentPackageInfo.value.endDate), 1)])) : _createCommentVNode("", true), ((_j = currentPackageInfo.value) === null || _j === void 0 ? void 0 : _j.boundlessFlag) === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, " 第" + _toDisplayString(currentPackageInfo.value.currentLimit) + "期/总" + _toDisplayString(currentPackageInfo.value.totalLimit) + "期 ", 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(PackageList, {
        iccid: _unref(iccid),
        message: kindlyReminder.value
      }, null, 8, ["iccid", "message"]), _hoisted_52, _createElementVNode("div", _hoisted_53, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kindlyReminder.value, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, _toDisplayString(item), 1);
      }), 128))])]), _createVNode(CardList, {
        ref_key: "cardList",
        ref: cardList
      }, null, 512), _createVNode(DiagnosePopup, {
        iccid: _unref(iccid),
        ref_key: "diagnosePopup",
        ref: diagnosePopup
      }, null, 8, ["iccid"])]), _createElementVNode("div", {
        class: "online-service",
        onTouchstart: _withModifiers(onTouchstart, ["prevent"]),
        onMousedown: _withModifiers(onMousedown, ["prevent"]),
        onTouchend: _withModifiers(onTouchend, ["prevent"]),
        onMouseup: _withModifiers(onMouseup, ["prevent"]),
        style: _normalizeStyle({
          bottom: "".concat(servicePosition.bottom, "px")
        })
      }, _hoisted_56, 44, _hoisted_54), _createVNode(_component_van_dialog, {
        show: _unref(realNameShow),
        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(realNameShow) ? realNameShow.value = $event : realNameShow = $event;
        }),
        title: _unref(title) ? _unref(title) : '实名认证',
        showConfirmButton: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_57, _toDisplayString(_unref(message) ? _unref(message) : '根据国家法律规定，使用前都需要实名认证，请先实名'), 1), _createElementVNode("div", _hoisted_58, [_withDirectives(_createElementVNode("button", {
            style: {
              "width": "50%",
              "font-size": "15px",
              "border": "transparent",
              "background": "#fff"
            },
            onClick: handleCancel
          }, " 取消 ", 512), [[_vShow, _unref(showCancelButton)]]), _createVNode(_component_wx_open_launch_weapp, {
            id: "launch-btn",
            username: "gh_5eac63f4d504",
            path: "pages/login/index?iccid=".concat(_unref(store).state.iccid),
            style: _normalizeStyle([{
              "display": "flex",
              "justify-content": "center",
              "background-color": "#437fff"
            }, _unref(showCancelButton) ? 'width: 50%' : 'width: 100%']),
            onClick: handleConfirm
          }, {
            default: _withCtx(function () {
              return [(_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
                type: "text/wxtag-template",
                style: {
                  "width": "100%",
                  "display": "block"
                }
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
                    default: _withCtx(function () {
                      return [_createTextVNode(".btn { padding: 15px 10px }")];
                    }),
                    _: 1
                  })), _createElementVNode("button", _hoisted_59, _toDisplayString(_unref(confirmButtonText) ? _unref(confirmButtonText) : '去实名'), 1)];
                }),
                _: 1
              }))];
            }),
            _: 1
          }, 8, ["path", "style"])])];
        }),
        _: 1
      }, 8, ["show", "title"]), _createVNode(_component_van_dialog, {
        show: _unref(realNameShow2),
        "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(realNameShow2) ? realNameShow2.value = $event : realNameShow2 = $event;
        }),
        title: _unref(title) ? _unref(title) : '实名认证',
        showConfirmButton: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_60, _toDisplayString(_unref(message) ? _unref(message) : '根据国家法律规定，使用前都需要实名认证，请先实名'), 1), _createElementVNode("div", _hoisted_61, [_withDirectives(_createElementVNode("button", {
            style: {
              "width": "50%",
              "font-size": "15px",
              "border": "transparent",
              "background": "#fff"
            },
            onClick: handleCancel
          }, " 取消 ", 512), [[_vShow, _unref(showCancelButton)]]), _createElementVNode("div", {
            style: _normalizeStyle(_unref(showCancelButton) ? 'width: 50%' : 'width: 100%'),
            onClick: handleConfirm2
          }, [_createElementVNode("button", _hoisted_62, _toDisplayString(_unref(confirmButtonText) ? _unref(confirmButtonText) : '去实名'), 1)], 4)])];
        }),
        _: 1
      }, 8, ["show", "title"]), _createVNode(_component_van_dialog, {
        show: _unref(codeShow),
        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
          return _isRef(codeShow) ? codeShow.value = $event : codeShow = $event;
        }),
        showConfirmButton: true,
        "confirm-button-text": "关闭"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_63, [_createElementVNode("img", {
            src: _unref(linkUrlImg),
            style: {
              "width": "100%",
              "height": "100%"
            }
          }, null, 8, _hoisted_64)])];
        }),
        _: 1
      }, 8, ["show"])], 544)), [[_vShow, pageShow.value]]);
    };
  }
});